<template>
  <div>
  <form novalidate>
    <div class="row  wizard-tab-container">
      <loader v-if="!isLoaded"></loader>

      <div class="col-lg-8 col-12">

        <h1 class="page-title" v-if="protocol">{{protocol.title}}</h1>
        <h3 class="page-sub-title" v-if="currentStage">
          {{'protocol.levelTitle' | trans}}: {{currentStage.description}}
        </h3>
        <h3 class="page-sub-title" v-if="currentStage">
          {{conditionTransfer}}
        </h3>

        <div class="row mt-2 mb-3" v-if="isPreviousDateSession && protocolsData && protocolsData.endDate" ref="maxTotalAtemptsCountError" id="maxTotalAtemptsCountError">
          <div class="col-12">
            <div class="alert-danger text-center" v-if="showDatePrevious">
              {{'protocol.enter_another_session_date' | trans}} <strong>{{minDate | toLocaleDateTime}}</strong>
            </div>
            <div class="alert-secondary text-center" v-if="!showDatePrevious">
              {{'protocol.end_session_date' | trans}}: <strong>{{minDate | toLocaleDateTime}}</strong>
            </div>
          </div>
        </div>

        <div class="alert alert-warning" v-if="maxTotalAtemptsCountError">
          {{'protocol.max_count_for_session' | trans}}
        </div>

        <div class="row" v-if="currentStage && !currentStage.selectedTasks">
          <div class="col-12" v-for="(category, index) in categories" :key="category.globalUuid">

            <toogle-view :title="category.title" :nameTitle="nameTitle"  v-if="category.tasks.length > 1">
              <table class="table table-sm table-fixed mt-2">
                <thead class="thead-light">
                <tr>
                  <th class="title-cell text-capitalize">{{'protocol.property' | trans}}</th>
                  <th class="action-cell"><mdc-checkbox v-model="category.active"  @change="changeActiveCategory(category)"/></th>
                </tr>
                </thead>
                <tbody class="gray-700">
                  <tr v-for="(task,index) in category.tasks" :key="task.globalUuid">
                    <td>{{task.description}}</td>
                    <td><mdc-checkbox v-model="task.active"/></td>
                  </tr>
                </tbody>
              </table>

            </toogle-view>

            <div class="row"  v-if="category.tasks.length === 1">
              <div class="col-12">
                <h3 class="page-sub-title mt-3 mb-0">
                  {{'protocol.categoryTitle' | trans}}: {{category.title}}
                </h3>
              </div>
              <div class="col-12">

                <table class="table table-sm table-fixed mt-2">
                  <thead class="thead-light">
                  <tr>
                    <th class="title-cell text-capitalize">{{'protocol.property' | trans}}</th>
                    <th class="action-cell"></th>
                  </tr>
                  </thead>
                  <tbody class="gray-700">
                  <tr v-for="(task,index) in category.tasks" :key="task.globalUuid">
                    <td>{{task.description}}</td>
                    <td><mdc-checkbox v-model="task.active"/></td>
                  </tr>
                  </tbody>
                </table>

              </div>
            </div>

          </div>

        </div>

        <div class="row" v-if="currentStage && currentStage.selectedTasks ">

          <div class="col-12" v-for="(category, index) in categories" :key="category.globalUuid"  v-if="activeTaskLength(category.tasks).length">

              <h3 class="page-sub-title mt-3">{{'protocol.categoryTitle' | trans}}: {{category.title}}</h3>

              <div v-if="!isMobile" class="wrapper-loader position-relative">
                <loader v-if="(!(previousDate && previousTime && previousTime.HH && previousTime.mm) && (isBCBA || isCurator) && isPreviousDateSession) || showDatePrevious" class="table-loader position-absolute without-img"
                        messages=""></loader>

    
                <table class="table table-sm table-fixed mt-2">
                  <thead class="thead-light">
                  <tr>
                    <th class="title-cell text-capitalize">{{'protocol.property' | trans}}</th>
                    <th>{{'protocol.result' | trans}}</th>
                    <th class="action-cell"></th>
                  </tr>
                  </thead>
                  <tbody class="gray-700">
                  <tr  v-for="(task,index) in category.tasks" :key="task.globalUuid" v-if="task.active">
                    <td>{{task.description}}</td>
                    <td class="results-cell">
                      <div class="mt-2" v-if="task.lastAnswers">
                        <span v-for="(answer, index) in task.lastAnswers" class="item-box" :class="{'hidden': task.lastAnswers.length > 5 && index < (task.lastAnswers.length -5)}">
                          {{answer}}
                        </span><span v-for="n in emptyLength(task.lastAnswers.length)" class="item-box-light"></span>
                      </div>
          
                      <div
                          class="mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"
                          v-for="(label, key) in currentStage.type.answers">
                        <div
                            class="mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded">
                          <input :id="'id'+index + task.globalUuid + label.id +key"
                                 type="radio" class="mdc-radio__native-control"
                                 v-model="task.answer"
                                 :name="'radios'+index + task.globalUuid + label.id +key"
                                 :key="label.title+index + task.globalUuid + label.id +key"
                                 :value="label.title+index + task.globalUuid + label.id +key"
                                 v-on:change="attemptChange(category.uuid, label.id, task, label.title, 1)">
                          <div class="mdc-radio__background"  :class="{'disabled' : task.disabled}"
                               :style="{background: label.color}">
                            <div class="mdc-radio__outer-circle"></div>
                            <div class="mdc-radio__inner-circle"></div>
                            <label :for="'id'+index + task.globalUuid + label.id + key">{{label.title}}</label>
                          </div>
                        </div>
                      </div>
                      <button type="button"
                              class="btn return-btn"
                              :disabled="!task.attempt"
                              @click.prevent="backToPreviousAttempt(task.globalUuid, category.uuid)">
                        <i class="material-icons mdc-button__icon">undo</i>
                      </button>

                    </td>
                    <td>
                      <span class="nowrap" v-if="task.toNextLevel || (task.isMastered && category.currentStageUuid != currentStage.uuid)">{{'protocol.mastering_btn' | trans}} </span>
                    </td>

                  </tr>
                  </tbody>
                </table>

                <p v-if="!activeTaskLength(category.tasks).length">{{'protocol.no_list_property' | trans}}</p>
    
              </div>
  
              <div class="mobile-table position-relative" v-if="isMobile">
    
                <div class="mobile-table__head">
                  <div class="cell text-capitalize">{{'protocol.property' | trans}}</div>
                  <div class="cell">{{'protocol.attempts' | trans}}</div>
                </div>
    
                <div class="mobile-table__body">
                  <div class="mobile-table__row"
                       v-for="(task,index) in category.tasks" :key="task.globalUuid" v-if="task.active">
        
                    <div class="container-load" v-if="task.answer">
                      <svg viewbox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" :class="{'animate': task.answer}">
                        <path d="M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z" stroke="#3da35a" fill="transparent"/>
                      </svg>
                    </div>
        
                    <div>
                      <div class="cell">{{task.description}} <span v-if="task.toNextLevel || (task.isMastered && category.currentStageUuid != currentStage.uuid)">({{'protocol.mastering_btn' | trans}})</span></div>
                      <div class="cell">{{task.attempt}}</div>
                    </div>
        
                    <div class="mt-2" v-if="task.lastAnswers">
                      <span v-for="(answer, index) in task.lastAnswers" class="item-box" :class="{'hidden': task.lastAnswers.length > 5 && index < (task.lastAnswers.length -5)}">
                        {{answer}}
                      </span><span v-for="n in emptyLength(task.lastAnswers.length)" class="item-box-light"></span>
                    </div>
        
                    <div class="mt-2 stimul-row"
                         :class="{'stimul-row-3' : (tasks.length/3) == 0}">
          
                      <div
                          class="mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"
                          v-for="(label, key) in currentStage.type.answers">
                        <div
                            class="mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded">
                          <input :id="'id'+index + task.globalUuid + label.id +key"
                                 type="radio" class="mdc-radio__native-control"
                                 v-model="task.answer"
                                 :name="'radios'+index + task.globalUuid + label.id +key"
                                 :key="label.title+index + task.globalUuid + label.id +key"
                                 :value="label.title+index + task.globalUuid + label.id +key"
                                 :disabled="task.disabled"
                                 v-on:change="attemptChange(category.uuid, label.id, task, label.title, task.attepmtsCount)">
                          <div class="mdc-radio__background"  :class="{'disabled' : task.disabled}"
                               :style="{background: label.color}">
                            <div class="mdc-radio__outer-circle"></div>
                            <div class="mdc-radio__inner-circle"></div>
                            <label :for="'id'+index + task.globalUuid + label.id + key">{{label.title}}</label>
                          </div>
                        </div>
                      </div>
                      <button type="button"
                              class="btn return-btn"
                              :disabled="!task.attempt"
                              @click.prevent="backToPreviousAttempt(task.globalUuid, category.uuid)">
                        <i class="material-icons mdc-button__icon">undo</i>
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            
          </div>
        </div>
  
        <div class="form-group row form-group-button stage-button mt-3"  v-if="!isClient">
          <div class="col-md-12">

            <button v-if="!isClient && currentStage && !currentStage.selectedTasks"
                    class="btn btn-primary btn-sm mr-2"
                    :disabled="disabledSelected"
                    @click.prevent="selectTaskList()">
              {{'protocol.choosePreferred' | trans}}
            </button>
      
            <button type="submit"
                    v-if="!isClient && currentStage && currentStage.selectedTasks"
                    class="btn btn-primary btn-sm mr-2"
                    :disabled="disabledSave"
                    @click.prevent="saveStage(false)">
              {{'buttons.save' | trans}}
            </button>

            <button type="submit"
                    v-if="isBCBA || isCurator"
                    class="btn btn-link btn-sm mr-2 mt-2 mt-md-0"
                    @click.prevent="closeSession()">
              {{'protocol.buttons.close_protocol' | trans}}
            </button>

            <router-link class="btn btn-link btn-sm mr-2 mt-2 mt-md-0"
                         :to="{ name: 'stage-list'}">
              <span>{{'buttons.back' | trans}}</span>
            </router-link>
    
          </div>
        </div>
        

      </div>

      <div class="col-lg-4">
        <instruction :text="execution"
                     :header="'protocol.execution' | trans"
                     :short-text-length="180">
        </instruction>
      </div>

    </div>


  </form>

  <mdc-dialog v-model="isConflictModalVisible"
              :title="'protocol.confirm_save_conflict_session' | trans"
              :accept="'user.save' | trans"
              :cancel="'user.cancel' | trans"
              @accept="saveSession(false)"
              @cancel="onModalClose">
  </mdc-dialog>

    <mdc-dialog v-model="isModalVisible"
                :title="'protocol.confirm_close_protocol' | trans"
                :accept="'protocol.buttons.close_protocol' | trans"
                :cancel="'user.cancel' | trans"
                @accept="saveStage(true)"
                @cancel="onModalClose">
    </mdc-dialog>

  </div>

</template>

<script>
  import axios from 'axios';
  import {mapGetters, mapState, mapActions} from 'vuex';
  import filter from 'lodash/filter';
  import UuidGenerator from '@/common/uuid/UuidGenerator';
  import Loader from '../../loader/components/Loader';
  import VueTimepicker from 'vue2-timepicker';
  import moment from 'moment';
  import Constants from '../../undesirableBehavior/Constants';
  import sortBy from 'lodash/sortBy';
  import map from 'lodash/map';
  import cloneDeep from 'lodash/cloneDeep';
  import forIn from 'lodash/forIn';
  import fill from 'lodash/fill';
  import toInteger from 'lodash/toInteger';
  import concat from 'lodash/concat';
  import dropRight from 'lodash/dropRight';
  import Instruction from '@/common/instruction/components/InstructionView';
  import trim from 'lodash/trim';
  import lang from '../../../lang/translator';
  import findIndex from 'lodash/findIndex';
  import drop from 'lodash/drop';
  import maxBy from 'lodash/maxBy';
  import ToogleView from '@/common/toggleViewList/components/ToggleView';

  export default {
    components: {Instruction, Loader, VueTimepicker, ToogleView},
    name: 'ChainReactionStage',
    props: {
      'name': null,
      'protocolData': null,
      'clientData': null,
      'protocolId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'stageId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },
    data() {
      return {
        apiUrl: '/protocols/assigned/pecs-with-discrimination/',
        apiClientUrl: '/users/clients/',
        apiCheckedUrl: '/protocols/assigned/',
        protocol: null,
        client: {},
        assignedProtocolId: null,
        loaded: false,
        isConflictModalVisible: false,
        protocolsData: cloneDeep(this.protocolData),
        isLoaded: false,
        rangeDateStart: null, //new Date(),
        duration: null,
        rangeTimeStart: {
          HH: "",
          mm: ""
        },
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
        showChangeDateSession: false,
        maxTotalAtemptsCountError: false,
        maxTotalAtemptsCount: 3000,
        hourRange: [0, 23],
        minuteRange: [0, 60],
        maxDateStart: this.getMaxDateStart(new Date()),
        tasks: [],
        timerId: null,
        totalAtemptsCount: 0,
        execution: '',
        disabledSave: true,
        currentSesssionDate: null,
        title: lang.get('protocol.confirm_close'),
        uuid: null,
        isOpenDisabled: false,
        currentStage: null,
        isModalVisible: false,
        currentDate: new Date(),
        isOpen: false,
        currentCategoryUuid: null,
        categories: null,
        nameTitle: lang.get('protocol.categoryTitle') + ': '
      };
    },
    computed: {

      ...mapState([
        'route',
      ]),
      ...mapGetters('auth', [
        'isClient',
        'isBCBA',
        'isCurator',
        'isPreviousDateSession',
        'previousDate',
        'previousTime',
        'previousDuration'
      ]),
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      ...mapState('protocol', [
        'protocolVuexData',
      ]),
      minDate() {
        return this.protocolsData && this.protocolsData.endDate ? moment(this.protocolsData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
      },
      showDatePrevious() {
        if (this.protocolsData && this.protocolsData.endDate && this.previousDate && this.isPreviousDateSession  && this.previousTime && this.previousTime.HH && this.previousTime.mm){

          let protocolDate = moment(this.minDate).unix();


          let sessionDate = new Date(this.previousDate.getFullYear(),
              this.previousDate.getMonth(),
              this.previousDate.getDate(),
              this.previousTime.HH,
              this.previousTime.mm);
          let previous = moment(sessionDate).unix();

          return previous <= protocolDate;

        }

        return false;
      },

      conditionTransfer() {
        let condition = this.currentStage.masteringCondition;

        if (condition) {
          return condition.ratio + " " + lang.get('protocol.condition_procent') + " " +
              condition.sessionCount + " " + lang.get('protocol.condition_trial') + " " +
              condition.trialCount + " " + lang.get('protocol.condition_session');
        }

      },

      disabledSelected(){

        let count = 0;

        forIn(this.categories, category => {

          count += this.activeTaskLength(category.tasks).length;

        });

        return count == 0;
      },
    },
    created() {
      this.fetchProtocolData();
    },
    async mounted() {
      this.currentSesssionDate = Math.round((new Date()).getTime() / 1000);
      this.uuid = UuidGenerator.v4();
      let entity = {
        id: this.uuid,
        type: 'assigned-session',
      };

      this.currentDate = this.previousDate ? this.previousDate : new Date();

      this.setEntity(entity);
    },
    methods: {

      ...mapActions('auth', [
        'setPreviousDate'
      ]),

      ...mapActions('appeals', [
        'setEntity',
      ]),

      activeTaskLength(taskList){
        return filter(taskList, task => {return task.active});
      },



      selectTaskList(){
        this.$set(this.currentStage, 'selectedTasks', true);

      },

      toggleView(uuid){
        this.currentCategoryUuid = uuid;
      },

      closeSession: function() {
        this.isModalVisible = true
      },
      onModalClose () {
        this.isModalVisible = false;
      },

      saveCurrentStep(){

        let max = maxBy(this.tasks, 'attempt').attempt;

        let lastDay = this.isPreviousDateSession ? moment(this.previousDate).format('YYYY-MM-DD') : this.today();

        forIn(this.tasks, item => {
          let lastDate = item.lastSessions.length ? item.lastSessions[item.lastSessions.length - 1].date : null;

          if(item.attempt < max){

            item.answers = concat(item.answers, 44);
            item.lastAnswersTotal++;
            item.attempt += 1;
            item.lastAnswers = concat(item.lastAnswers, lang.get('protocol.task_types.answers.titles.no_data'));
            item.lastAnswersCount.push(1);
            item.disabled = true;



            if (lastDate === lastDay) {
              item.lastSessions[item.lastSessions.length - 1].attempts = concat(item.lastSessions[item.lastSessions.length - 1].attempts, 44);
            } else{
              item.isMastered = false;
              item.lastSessions.push({
                date: lastDay,
                attempts: [44],
                mastered: false
              })
            }

            this.$set(item, 'toNextLevel', this.nextLevel(item));

          }

          item.disabled = false;

        });
      },

      toggleViewDisabled(position){
        
        let stage = this.protocol.stages[position];
        stage.isOpenDisabled = !stage.isOpenDisabled;
        this.$set(this.protocol.stages, position, stage)

      },

      goToPrevLevel(uuid, task){

        let index = findIndex(this.tasks, function(task) {

          return uuid.globalUuid == uuid;

        });

        this.$set(this.tasks[index], 'newStageUuid', this.protocol.stages[this.currentStage.position +- 1].uuid);

      },

      today() {
        let dateTime = new Date();
        let dateWithTimezone = null;
        if (this.client.timezone) {
          dateWithTimezone = moment().
              tz(this.client.timezone).
              add(-(moment().utcOffset()), 'm')._d;
        } else{
          dateWithTimezone = dateTime.getTime() +
              (Math.abs(dateTime.getTimezoneOffset()) *
                  Constants.SECONDS_PER_MINUTE * 1000);
        }

        return moment(dateWithTimezone).format('YYYY-MM-DD');
      },

      ...mapActions('protocol', [
        'setProtocol',
      ]),

      changeNumber(event){
        if (event.shiftKey || !((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 46 || event.keyCode == 8|| (event.keyCode >= 35 && event.keyCode <= 40) )) {
          event.preventDefault();
        }
      },

      emptyLength(length){
        return 5-length > 0 ? 5-length : 0;
      },

      getMaxDateStart: function(date) {
        let clientTimeZoneOffset = moment().tz(this.clientData.timezone)._offset;
        let dateTime = moment(date, 'YYYY-MM-DD HH:mm').toDate();
        let dateWithTimezone = moment(dateTime.getTime() +
            (Math.abs(clientTimeZoneOffset) *
                Constants.SECONDS_PER_MINUTE * 1000)).toDate();

        return dateWithTimezone;
      },

      fetchData: async function() {
        try {
          let params = {};
          if(this.isPreviousDateSession && this.previousDate) {
            let newDate = moment(this.previousDate).format('YYYY-MM-DD');
            let newDateUnix = moment.utc(newDate, 'YYYY-MM-DD').unix();

            params = {
              date: newDateUnix
            };

          }
          let response = await axios.get(this.apiUrl + this.protocolId + '/show-stage/' + this.stageId, {params: params});
          return response;
        } catch (e) {
          console.info(e)
          this.$router.push({name: 'client-edit', params: { clientId: this.clientData.id || this.assignedProtocolId }});
        }
      },

      fetchProtocolData: async function() {

        let response = await this.fetchData();
        if (response) {
          this.currentStage = response.data.data;
          this.$set(this.currentStage, 'selectedTasks', false);
          this.assignedProtocolId = this.protocolsData.assigneeId;
          this.getClient(this.clientId || this.assignedProtocolId);
          this.initProtocolData();
        }
        
      },

      initProtocolData: function() {
        this.protocol = cloneDeep(this.protocolsData.protocol);
        this.execution = this.protocol.execution;


        forIn(this.currentStage.categories, category => {

          category.tasks = map(category.tasks, (task, index) => {

            let lastSessions = task.lastSessions ? task.lastSessions : [];
            this.$set(task, 'lastSessions', lastSessions);
            task.attempt = 0;
            task.attepmtsCount = '1';
            let lastAnswers = task.lastAnswers ? task.lastAnswers : [];
            this.$set(task, 'lastAnswers', lastAnswers);
            let lastAnswersCount = task.lastAnswersCount ? task.lastAnswersCount : [];
            this.$set(task, 'lastAnswersCount', lastAnswersCount);
            this.$set(task, 'answers', []);
            this.$set(task, 'type', this.currentStage.type);
            this.$set(task, 'toNextLevel', this.nextLevel(task));

            return task;

          });

        });

        this.categories = cloneDeep(this.currentStage.categories);

        forIn(this.protocol.stages, item => {
          item.isOpenDisabled = false;
        });

        this.isLoaded = true;
      },

      getClient: async function(clientId) {
        try {
          let response = await axios.get(this.apiClientUrl + clientId);
          this.client = response.data.data;
        } catch (error) {
          console.dir(error)
        } finally {
          this.loaded = true
        }
      },
      backToPreviousPage() {
        if (this.clientId || this.assignedProtocolId) {
          this.$router.push({name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId }});
        }
        else {
          this.$router.push({name: 'protocols'});
        }
      },

      onModalClose () {
        this.isConflictModalVisible = false;
      },

      changeActiveCategory(category){
        forIn(category.tasks, (item, index) => {

          item.active = category.active;

        });
      },

      attemptChange: function(categoryUuid, answer, task, title, answerCount) {

        if (this.timerId){
          clearTimeout(this.timerId);
        }

        let answerListCount = 1;
        let answerList = fill(new Array(answerListCount), title);
        let answerListId = fill(new Array(answerListCount), answer);
        let lastDate = task.lastSessions.length ? task.lastSessions[task.lastSessions.length - 1].date : null;
        let lastDay = this.isPreviousDateSession ? moment(this.previousDate).format('YYYY-MM-DD') : this.today();

        this.totalAtemptsCount = this.totalAtemptsCount + answerListCount;
        if (this.totalAtemptsCount <= this.maxTotalAtemptsCount){
          this.maxTotalAtemptsCountError = false;

          let currentCategoryIndex = findIndex(this.categories, category => {return category.uuid === categoryUuid});
          let currentTaskIndex = findIndex(this.categories[currentCategoryIndex].tasks, taskCurrent => {return taskCurrent.globalUuid == task.globalUuid});

          forIn(this.categories[currentCategoryIndex].tasks, (item, index) => {
            if (item.globalUuid == task.globalUuid) {

                item.answers = concat(item.answers, answerListId);
                item.attempt = item.attempt + answerListCount;
                this.$set(this.categories[currentCategoryIndex].tasks[index], 'lastAnswers', concat(item.lastAnswers, answerList));
                item.lastAnswersCount.push(answerCount);

  
                if (lastDate === lastDay) {
                  item.lastSessions[task.lastSessions.length - 1].attempts = concat(item.lastSessions[task.lastSessions.length - 1].attempts, answerListId);
                } else {
                  item.isMastered = false;
                  item.lastSessions.push({
                    date: lastDay,
                    attempts: answerListId,
                    mastered: false
                  })
                }

                item.lastAnswersTotal += answerListCount;

                item.toNextLevel = this.nextLevel(item);

            }
          });

        } else{
          this.maxTotalAtemptsCountError = true;
          this.totalAtemptsCount = this.totalAtemptsCount - answerListCount;
          setTimeout(() => {
            this.$refs.maxTotalAtemptsCountError.scrollIntoView();
          }, 100);
        }

        this.disabledSave = false;

        this.timerId = setTimeout(function() {
          task.answer = null;
          //task.attepmtsCount = '1';
        }, 200);

      },


      backToPreviousAttempt: function(id, categoryUuid) {

        let currentCategoryIndex = findIndex(this.categories, category => {return category.uuid === categoryUuid});

        if(currentCategoryIndex >= 0){
          forIn(this.categories[currentCategoryIndex].tasks, (item, key) => {

            if (item.globalUuid == id) {
              let lastAnswersCount = item.lastAnswersCount[item.lastAnswersCount.length - 1];

              item.answers = dropRight(item.answers, lastAnswersCount);
              item.lastAnswers = dropRight(item.lastAnswers, lastAnswersCount);
              item.attempt = item.attempt - lastAnswersCount;
              this.totalAtemptsCount  = this.totalAtemptsCount - lastAnswersCount;

              item.lastAnswersCount.pop();
              item.disabled = false;
              this.$set(item, 'disabledBack', true);

              item.lastSessions[item.lastSessions.length - 1].attempts =  dropRight(item.lastSessions[item.lastSessions.length - 1].attempts, lastAnswersCount);

              if(!item.lastSessions[item.lastSessions.length - 1].attempts.length && !item.lastSessions[item.lastSessions.length - 1].isMastered){
                item.lastSessions.pop();
              }

              item.lastAnswersTotal -= lastAnswersCount;

              this.$set(this.categories[currentCategoryIndex].tasks[key], 'toNextLevel', this.nextLevel(item));

              if(!this.totalAtemptsCount){
                this.disabledSave = true;
              }
            }

          });
        }
      },

      async checkSessionVersion() {

        let sessionVersion = axios.get(this.apiCheckedUrl + this.protocolsData.id + '/is-version-equal/' + this.protocolsData.protocol.majorVersion);

        return sessionVersion;

      },


      async saveStage(close, stageId) {
        this.isLoaded = false;

        let checkVersion = await this.checkSessionVersion();
        let result = this.showChangeDateSession ? await this.$validator.validate('duration') : true;

        if (result && checkVersion.data.data.result) {
          this.saveSession(close, stageId);
        } else{
          this.isLoaded = true;
          this.isConflictModalVisible = true;
        }

      },

      saveSession: async function(close, stageId) {
        let that = this;
        let isSaved;
        this.isLoaded = false;
        this.errors.clear();

        let sessionDate = null;
        let sessionEndDate = null;
        let timeSessionDate = null;
        let timeSessionEndDate = null;

        if (this.isPreviousDateSession && this.previousTime.HH){
          let clientTimeZoneOffset = moment().tz(this.client.timezone)._offset;
          sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(),
              this.previousDate.getMonth(),
              this.previousDate.getDate(),
              this.previousTime.HH,
              this.previousTime.mm));
          timeSessionDate = moment(sessionDate).unix() - (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE);
          timeSessionEndDate = moment(sessionDate).unix() - (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE) + this.previousDuration * Constants.SECONDS_PER_MINUTE;
        }

        let taskReactions = [];

        forIn(this.categories, category =>{
          forIn(category.tasks, task => {
            taskReactions.push(task);
          });

        });


        taskReactions = map(taskReactions, (task) => {

          delete task['lastAnswers'];
          delete task['lastAnswersCount'];
          delete task['type'];
          delete task['attepmtsCount'];
          delete task['lastAnswersTotal'];
          return task;

        });
        

        let startedAt = this.isPreviousDateSession ? timeSessionDate : (this.currentSesssionDate ? this.currentSesssionDate : Math.round((new Date()).getTime() / 1000));
        let finishedAt = this.isPreviousDateSession ? timeSessionEndDate : Math.round((new Date()).getTime() / 1000);

        let stageActiveList = filter(this.protocol.stages, ['isClosed', false]);

        isSaved = axios.post(this.apiUrl + this.protocolId + '/sessions',
            {

              'index': that.currentStage.position,
              'uuid': that.currentStage.uuid,
              'close': close,
              'majorVersion': this.protocol.majorVersion,
              'newStageUuid': stageId,
              'assignedSessions': [
                {
                  'uuid': this.uuid,
                  'startedAt': startedAt ,
                  'finishedAt': finishedAt,
                  'stimuli': taskReactions,
                  'type': that.currentStage.type
                },
              ],

            }).then(async response => {
                if(this.isClient) {
                  this.$router.push({name: 'available-protocols'});
                }
                this.setProtocol(null);
                if (close){
                  this.$router.push({name: 'results', params: { clientId: this.clientId || this.assignedProtocolId, protocolId: this.protocolId }});
                } else {

                  if (stageActiveList.length == 1){
                    this.$router.push({name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId }});
                  } else {
                    this.$router.push({name: 'stage-list', params: { clientId: this.clientId, protocolData: null}});
                  }

                }
            }).catch(error => {
              console.info(error);
              this.$router.push({name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId }});
            });

      },

      async closeStage() {

        this.saveSession(true);

      },

      nextLevel: function(item) {
        let positive = filter(this.currentStage.type.answers, function(item) { return item.himself; });
        let positiveAnswer = positive[0].id;
        let toNextLevel = false;


        let trialCount = this.currentStage.masteringCondition.trialCount;
        let sessionCount = this.currentStage.masteringCondition.sessionCount;

        if(item.isMastered){
          return true;
        }


        if(item.lastSessions.length >= sessionCount){

          let sortedSession = sortBy(item.lastSessions, (date) => {
            return moment(date.date, 'YYYY-MM-DD').unix();
          });

          let lastSessions = drop(sortedSession, item.lastSessions.length - sessionCount);
          let mastered = false;
          let countMastered = 0;

          forIn(lastSessions, (answerList, index) => {

            let lastSessionAtempts = dropRight(answerList.attempts, answerList.attempts.length - trialCount);
            let lastSessionAtemptsCount = lastSessionAtempts.length;




            if (lastSessionAtemptsCount >= trialCount || answerList.isMastered) {

              if(answerList.isMastered){

                countMastered++;

              } else{

                let positiveAnswerCount = filter(lastSessionAtempts, function (item) {
                  return item == positiveAnswer;
                }).length;
                let trial = (positiveAnswerCount * 100 / lastSessionAtemptsCount) >= this.currentStage.masteringCondition.ratio;
                if (trial) {
                  countMastered++;
                } else {
                  mastered = false
                }

              }


            } else{
              return false;
            }

          });

          if(countMastered >= sessionCount){
            mastered = true;
          }

          toNextLevel =  mastered;

        } else {
          return false;
        }

        return toNextLevel;

      },


    },
    watch: {
      async previousDate(newValue,oldValue) {

        if(oldValue){

          let oldDay = oldValue ? moment(oldValue).format('YYYY-MM-DD') : this.today();
          let newDay = moment(newValue).format('YYYY-MM-DD');
          let endDate = this.protocolsData.endDate ? moment(this.protocolsData.endDate.date).format('YYYY-MM-DD') : null;

          if(oldDay !== this.today()){

            forIn(this.categories, (category, categoryIndex) => {

              category.tasks = map(category.tasks, (task, index) => {

                if(oldDay == endDate) {

                  let lastSessionAnswersCount = task.lastAnswers.length >
                      task.answers.length ?
                      task.lastAnswers.length - task.answers.length :
                      0;
                  let lastAnswers = lastSessionAnswersCount > 0 ?
                      drop(task.lastAnswers, lastSessionAnswersCount) :
                      task.lastAnswers;

                  this.$set(task, 'lastAnswers', lastAnswers);

                  let oldLastSessionIndex = findIndex(task.lastSessions, lastSession => {
                    return lastSession.date === oldDay;
                  });

                  if (oldLastSessionIndex >= 0){

                    let attemptsCount = task.lastSessions[oldLastSessionIndex].attempts ? task.lastSessions[oldLastSessionIndex].attempts.length - lastSessionAnswersCount : 0;
                    let attempts = attemptsCount > 0 ? drop(task.lastSessions[oldLastSessionIndex].attempts, attemptsCount) : [];
                    let newAttempts = attemptsCount > 0 ? dropRight(task.lastSessions[oldLastSessionIndex].attempts, lastSessionAnswersCount) : [];

                    task.lastSessions[oldLastSessionIndex].attempts = attempts;
                    task.lastSessions.push({
                      date: newDay,
                      attempts:  newAttempts,
                      mastered: false
                    });
                    task.isMastered=false;

                  }

                } else{

                  task.lastSessions = map(task.lastSessions, lastSession => {

                    if (lastSession.date === oldDay){
                      lastSession.date = newDay;
                    }

                    return lastSession;

                  });

                }

                //task.isMastered = false;
                task.toNextLevel = this.nextLevel(task);

                return task;

              });

            });

          }

        }



      },


      isPreviousDateSession(newValue) {
        if (!newValue) {
          this.currentDate = this.previousDate;
          this.setPreviousDate(null);

        }  else{

          this.setPreviousDate(this.currentDate);

        }
      }
    }



  }
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/PecsWithDiscriminationStage.vue